import React from "react";
import WebhookAPI_Json from "./WebhookAPI_JSON/WebhookAPI_Json";
import WebhookAPI_Json_bank from "./WebhookAPI_JSON/WebhookAPI_Json_bank";
import WebhookAPI_Json_Sale from "./WebhookAPI_JSON/WebhookAPI_Json_Sale";
import WebhookAPI_Json_Payment from "./WebhookAPI_JSON/WebhookAPI_Json_Payment";
import WebhookAPI_Json_Failed from "./WebhookAPI_JSON/WebhookAPI_Json_Failed";

function WebhookAPI() {
  return (
    <div class="idocs-content">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <section id="idocs_content" class="mt-20 mb-20">
              <h1> Webhook API (Callback Response)</h1>
              <hr />
            </section>

            <p>
              Webhooks are user-defined HTTP callbacks operating at the
              server-to-server (S2S) communication levels.
            </p>

            <p>
              The S2S callback is a more recommendable feature while integrating
              with Safexpay.
            </p>

            <p>
              Basically, Safexpay will send the final transaction response to
              the merchant via browser redirection on real-time transactions.
            </p>

            <p>
              However, this browser redirection may not be successful due to
              network issues or some other technical glitch, and the transaction
              may get dropped (between Safexpay and Merchant).
            </p>

            <p>
              In such events, the merchant cannot complete the order processing
              at their end. Forsuch cases, this callback feature can be used
              effectively.
            </p>

            <h4>How can merchants use Webhooks?</h4>

            <p>
              <b>Step 1:</b> The merchants should create their server URL (Ex:
              www.abc.com/success/response) and share it with <b>Safexpay</b>{" "}
              and its server IP address. It is the URL at which the transaction
              response from Safexpay will hit.
            </p>

            <p>
              <b>Step 2:</b> Configure the merchant’s Server URL at its back
              end, mapping it against the ProductionMID that has been shared.
            </p>

            <p>
              <b>Step 3:</b> To establish the connection, <b>Safexpay</b> will
              Whitelist the webhook URL provided by the merchant in its systems.
              The merchant also needs to whitelist the following IP address as
              per the dependency upon the firewall side to receive a response
              from the Safexpay servers.
            </p>

            <p>
              <b>Step 4 :</b> <b>Safexpay</b> will send an S2S response to the
              merchant server URL. The Merchant’s server URL should be capable
              of handling the following content types:
            </p>

            <ul>
              <li>FormData</li>
              <li>application/x-www-form-urlencode</li>
              <li>application/json</li>
            </ul>

            <p className="para-blod">
              So, while creating the server URL, the merchant needsto ensure
              that it can accept the data in the above content formats.
            </p>

            <p>
              <b>Step 5 :</b> Merchant must share the below details for
              configuring the Webhook at Safexpay Server to the Integration’s
              email id.
            </p>

            <p className="para-underline">
              Prerequisites for implementing WebHook :
            </p>

            <p>
              For Webhook Management we need following information from the
              merchant :
            </p>
            <ul>
              <li>
                Webhook URL: (required to push our transaction details at
                merchant URL)
              </li>
              <li>
                Webhook IP: (required to push our transaction details at
                merchant URL)
              </li>
              <li>
                Web hook Event Description: List below(needs to be selected by
                Merchant)
              </li>
              <li>
                Web hook SSL Certificate: (for URL whitelisting - for above URL)
              </li>
            </ul>

            <p>
              <b>Step 6 :</b> Webhook can be triggered for any ofthe following
              events as per the requirement
            </p>

            {/* <p className="para-blod">Note :</p> */}

            <p className="para-blod">The event list are below:</p>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-color">
                  <th>Event No </th>
                  <th>EventName</th>
                  <th> EventDescription</th>
                </tr>
                <tr>
                  <td>0</td>
                  <td>AuthRR</td>
                  <td>Auth Request Received</td>
                </tr>

                <tr>
                  <td>1</td>
                  <td>AuthVRR</td>
                  <td>Auth Void Request Received</td>
                </tr>

                <tr>
                  <td>2</td>
                  <td>CaptureRR</td>

                  <td>Capture Request Received</td>
                </tr>

                <tr>
                  <td>3</td>
                  <td>SaleRR</td>
                  <td>Sale Request Received</td>
                </tr>

                <tr className="table-colour-sec">
                  <td>4</td>
                  <td>RefundRI</td>
                  <td>Refund request Initiated</td>
                </tr>

                <tr>
                  <td>5</td>
                  <td>RequestSTPGoB</td>
                  <td>Request Sent To Payment Gateway / Bank</td>
                </tr>

                <tr>
                  <td>6</td>
                  <td>ResponseRFPGoB</td>
                  <td>Response Received From Payment Gateway / Bank</td>
                </tr>

                <tr>
                  <td>7</td>
                  <td>VerificationRSTPGoB</td>
                  <td>Verification Request Sent To Payment Gateway/Bank</td>
                </tr>

                <tr>
                  <td>8</td>
                  <td>VerificationRRFPGoB</td>
                  <td>
                    Verification Response Received From Payment Gateway / Bank
                  </td>
                </tr>

                <tr>
                  <td>9</td>
                  <td>NoRRFPGoB</td>
                  <td>No Response Received from Payment Gateway/Bank</td>
                </tr>

                <tr>
                  <td>10</td>
                  <td>AuthRP</td>
                  <td>Auth Request Processed</td>
                </tr>

                <tr>
                  <td>11</td>
                  <td>AuthRF</td>
                  <td>Auth Request Failed</td>
                </tr>

                <tr>
                  <td>12</td>
                  <td>AuthVRP</td>
                  <td>Auth Void Request Processed</td>
                </tr>

                <tr>
                  <td>13</td>
                  <td>AuthVRF</td>
                  <td>Auth Void Request Failed</td>
                </tr>

                <tr>
                  <td>14</td>
                  <td>CaptureRP</td>
                  <td>Capture Request Processed</td>
                </tr>

                <tr>
                  <td>15</td>
                  <td>CaptureRF</td>
                  <td>Capture Request Failed</td>
                </tr>

                <tr className="table-colour-sec">
                  <td>16</td>
                  <td>SaleRP</td>
                  <td>Sale Request Processed</td>
                </tr>

                <tr className="table-colour-sec">
                  <td>17</td>
                  <td>SaleRF</td>
                  <td>Sale Request Failed</td>
                </tr>

                <tr className="table-colour-sec">
                  <td>18</td>
                  <td>RefundRP</td>
                  <td>Refund Request Processed</td>
                </tr>

                <tr>
                  <td>19</td>
                  <td>RefundRF</td>
                  <td>Refund Request Failed</td>
                </tr>

                <tr className="table-colour-sec">
                  <td>20</td>
                  <td>ReconciledWRGoB</td>
                  <td>Reconciled With Payment Gateway / Bank</td>
                </tr>

                <tr>
                  <td>21</td>
                  <td>SettlementD</td>
                  <td>Settlement Done</td>
                </tr>

                <tr>
                  <td>22</td>
                  <td>ReconciledM</td>
                  <td>Reconciled Mismatch</td>
                </tr>

                <tr>
                  <td>23</td>
                  <td>MerchantPD</td>
                  <td>Merchant Payout Done </td>
                </tr>

                <tr className="table-colour-sec">
                  <td>24</td>
                  <td>CancelledBC</td>
                  <td>Cancelled By Customer</td>
                </tr>

                <tr className="table-colour-sec">
                  <td>25</td>
                  <td>Aborted</td>
                  <td>Aborted</td>
                </tr>

                <tr>
                  <td>26</td>
                  <td>HostTO</td>
                  <td>Host Time Out</td>
                </tr>

                <tr>
                  <td>27</td>
                  <td>AmountM</td>
                  <td>Amount Mismatch</td>
                </tr>
              </tbody>
            </table>

            <p>
              Webhook can be triggered for any of the above mentioned events as
              per the requirement.
              <p>
                <span className="para-blod">Note:</span> The Events below
                highlighted in green background are the one’s mostly opted by
                merchants covering all their Webhook requirements are marked in
                the above list.
              </p>
            </p>

            <ul>
              <li>
                As the Webhook response hits the merchant’s server URL, Merchant
                can in return send an Acknowledgment in the receipt with the
                success status ‘True’ as a JSON object
              </li>

              <li>
                The merchant has to send the acknowledgement forthe webhook
                response sent to the merchant. Until no response is received
                from the merchant the webhook API will be called for those txn
                from Safexpay.
              </li>
              <li>
                Webhook scheduler to be set with 10 min interval time. In this
                scheduler the current day’s txns to be sent.
              </li>
              <li>
                Once the response is received from merchant, the
                schedulershouldn’t pick those txn again in the next job.
              </li>
              <li>
                Abort txn scheduler- This will be schedule at 3:00 AM for all
                the pending statustxn which will change the txn status from
                pending to failed.
              </li>
              <li>
                The scheduler should pick the txn according to the txn change
                status [event time]
              </li>
            </ul>
          </div>
          <div class="col-md-4">
            <div class="webhook-scroll-sec">
              <WebhookAPI_Json />
              <WebhookAPI_Json_bank />
              <WebhookAPI_Json_Sale />
              <WebhookAPI_Json_Payment />
              <WebhookAPI_Json_Failed />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default WebhookAPI;
